// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Vetting40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Vetting40: FC<Vetting40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m27.667 16.278-9.445 9.389-5.888-5.861 2.054-2.028 3.834 3.916 7.416-7.361 2.029 1.945Z" />
            <path
                d="M16.289 4.894c1.864-2.457 5.559-2.457 7.423 0a4.658 4.658 0 0 0 4.033 1.833l.312-.033c3.056-.42 5.669 2.193 5.25 5.248l-.034.313a4.658 4.658 0 0 0 1.833 4.033c2.458 1.864 2.457 5.56 0 7.423l-.244.198a4.658 4.658 0 0 0-1.556 4.148c.407 2.96-2.033 5.504-4.963 5.279l-.286-.03a4.658 4.658 0 0 0-4.345 1.8l-.18.222c-1.851 2.16-5.211 2.16-7.063 0l-.18-.223a4.658 4.658 0 0 0-4.346-1.8l-.285.03c-2.836.22-5.211-2.157-4.993-4.993l.03-.285a4.659 4.659 0 0 0-1.557-4.148l-.243-.198c-2.38-1.805-2.455-5.33-.223-7.242l.223-.181a4.659 4.659 0 0 0 1.832-4.033l-.032-.313c-.42-3.055 2.193-5.668 5.248-5.248a4.66 4.66 0 0 0 4.149-1.556l.197-.244Zm5.191 1.692a1.858 1.858 0 0 0-2.96 0 7.458 7.458 0 0 1-6.958 2.882 1.858 1.858 0 0 0-2.093 2.094 7.459 7.459 0 0 1-2.882 6.958 1.857 1.857 0 0 0 0 2.96 7.46 7.46 0 0 1 2.882 6.958 1.858 1.858 0 0 0 2.093 2.093 7.459 7.459 0 0 1 6.958 2.882c.744.98 2.217.98 2.96 0a7.46 7.46 0 0 1 6.96-2.882 1.858 1.858 0 0 0 2.092-2.093 7.46 7.46 0 0 1 2.882-6.959c.98-.743.98-2.216 0-2.96a7.458 7.458 0 0 1-2.882-6.957 1.858 1.858 0 0 0-2.093-2.094 7.46 7.46 0 0 1-6.959-2.882Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Vetting40;
